export const silaeAddonCacheKeys = {
  silae_addon: () => ['silae_addon'] as const
}
